module.exports = __webpack_public_path__ + "static/corporate-staff-transport-sm-560dc0f94b7ef573c311512177f2a1de.jpg";